import type { IBlockField } from '../blockFields'
import type { BLOCK_TYPE } from '../enums'
import type { ReferenceId } from '../ids'
import type { BlockReference } from '../references'

import type { IBlock, BlockBaseSettings } from './base'

/**
 * PresetChoiceField as field which can have configured choice of options
 */
export interface PresetChoiceField extends IBlockField {
  options?: string[]
}

/**
 * ENUM for sources from where the Contact data can be fetched and prefilled
 *
 * This can be extended to also fetch data from external sources
 */
export enum PrefillContactSource {
  ENTITY = 'entity'
}

/**
 * Setting for the case when the source of prefilling data into contact mode is Entity
 *
 * This can be extended to have CONTEXT_MODE, ENTITY_FINDER, etc.
 */
export enum PrefillContactEntityMode {
  AUTH_MODE = 'auth'
}

export interface PrefillContactSettings {
  source: PrefillContactSource
  mode: PrefillContactEntityMode
}

/**
 * ContactBlockReference is used to autofill data into the submission of
 * this block when this block is hidden using Display conditions.
 */
export interface ContactBlockReference extends BlockReference {
  meaning: string
}

export interface ContactBlock extends IBlock {
  type: BLOCK_TYPE.CONTACT
  settings: BlockBaseSettings & {
    /**
     * The purpose will be added to the entity created by this block
     * If purpose is "customer" the length of this array should be 1, other wise free text is allowed.
     */
    purpose: string[]
    /**
     * Settings to prefill Contact Block. Currently support source is Entity in "AUTH" mode.
     *
     * This can be extended to fetch data from external sources such as APIs and apps.
     * Ideally, prefill and autofill should not be enabled at the same time, hence it's optional.
     */
    prefillSettings?: PrefillContactSettings
    fields: {
      salutation: PresetChoiceField
      /**
       * The title could also be a PresetChoiceField but currently the title options are hardcoded in the journey app
       */
      title: IBlockField
      firstName: IBlockField
      lastName: IBlockField
      email: IBlockField
      telephone: IBlockField
      birthDate: IBlockField
    }
  }
  references: Record<ReferenceId, ContactBlockReference>
}
